import React, { FC, ReactNode } from "react";
import { styled } from "@material-ui/styles";

import AppSidebar from "../../components/redesign/modules/AppSidebar";
import TopBar from "../../components/redesign/modules/TopBar";
import { PageMetaProvider, usePageMeta } from "./PageMetaContext";

type AppShellLayoutProps = {
  title: string;
  subtitle?: string;
  children: ReactNode;
};

const Root = styled("div")({
  display: "flex",
  height: "100vh",
  overflow: "hidden",
  fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, sans-serif !important',
});

const ContentColumn = styled("div")({
  flex: 1,
  display: "flex",
  flexDirection: "column",
  minWidth: 0,
});

const ContentArea = styled("div")(({ theme }) => ({
  flex: 1,
  overflow: "auto",
  background: theme.palette.brand.gray50,
  padding: 24,
  display: "flex",
  flexDirection: "column",
}));

const ShellTopBar: FC = () => {
  const { meta } = usePageMeta();
  return <TopBar title={meta.title} subtitle={meta.subtitle} />;
};

const AppShellLayout: FC<AppShellLayoutProps> = ({ title, subtitle, children }) => (
  <PageMetaProvider initial={{ title, subtitle }}>
    <Root>
      <AppSidebar />
      <ContentColumn>
        <ShellTopBar />
        <ContentArea>{children}</ContentArea>
      </ContentColumn>
    </Root>
  </PageMetaProvider>
);

export default AppShellLayout;
